
import React from "react";
import { Card } from "@/components/ui/card";
import { LayoutDashboard, AlertCircle, Plus } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { MarketDialog } from "../markets/MarketDialog";
import { MarketCard } from "./MarketCard";
import { DatabaseAlert } from "./DatabaseAlert";
import { useCurrencyMarkets } from "./hooks/useCurrencyMarkets";

export const CurrencyMarketSection: React.FC = () => {
  const {
    markets,
    loading,
    dbError,
    isDialogOpen,
    setIsDialogOpen,
    saveMarkets,
    toggleMarketActive,
    defaultMarket,
    currentActiveMarkets
  } = useCurrencyMarkets();

  return (
    <div className="md:col-span-2">
      <Card className="p-6 shadow-card hover:shadow-card-elevated border border-gray-200 rounded-xl dark:bg-[rgba(30,32,47,0.6)] dark:border-[rgba(60,63,84,0.6)] dark:backdrop-blur-sm transition-all duration-300 settings-card">
        <div className="flex items-center gap-3 mb-6">
          <div className="p-2 rounded-full bg-custom-primaryLight dark:bg-custom-primary/20">
            <LayoutDashboard className="h-5 w-5 text-custom-dark dark:text-custom-secondaryLight" />
          </div>
          <h2 className="text-2xl font-bold text-custom-dark dark:text-gray-100">Devises Et Marchés</h2>
        </div>

        <p className="text-sm text-gray-600 dark:text-gray-300 mb-8">
          Développez votre entreprise en atteignant de nouveaux marchés et en utilisant leurs devises locales. Activez ou désactivez des marchés selon vos besoins.
        </p>

        <DatabaseAlert dbError={dbError} />

        {/* Marchés activés */}
        <div className="space-y-4 mb-6">
          {loading ? (
            <div className="animate-pulse flex space-x-4">
              <div className="rounded-lg bg-slate-200 dark:bg-slate-700 h-12 w-full"></div>
            </div>
          ) : (
            markets.map((market) => (
              <MarketCard 
                key={market.country}
                market={market}
                toggleMarketActive={toggleMarketActive}
              />
            ))
          )}
        </div>

        {/* Alert */}
        <Alert variant="warning" className="mb-6">
          <AlertCircle className="h-4 w-4" />
          <AlertDescription className="text-sm">
            N'oubliez pas de mettre à jour vos prix à chaque changement de devise !
          </AlertDescription>
        </Alert>

        {/* Bouton d'update */}
        <div className="flex justify-end">
          <Button 
            variant="outline" 
            onClick={() => setIsDialogOpen(true)}
            className="border-custom-primary text-custom-primary hover:bg-custom-primaryLight hover:text-custom-primary dark:border-custom-secondaryLight dark:text-custom-secondaryLight dark:hover:bg-custom-primary/20 transition-colors"
          >
            <Plus className="h-4 w-4 mr-2" />
            Mettre à jour les marchés
          </Button>
        </div>
      </Card>
      
      {/* Dialog pour sélectionner les marchés */}
      <MarketDialog 
        open={isDialogOpen} 
        onOpenChange={setIsDialogOpen}
        onSave={saveMarkets}
        currentDefaultMarket={defaultMarket}
        currentActiveMarkets={currentActiveMarkets}
      />
    </div>
  );
};
